// extracted by mini-css-extract-plugin
export default {"createBtnContainer":"user-management_createBtnContainer__YH-ED","link":"user-management_link__11Jre"};